import _ from 'lodash';
import * as actionTypes from '../actions/ActionTypes';
import Config from '../../utils/Configuration';

function initState() {
    const updatedState = {
        hasMessage: false,
        type: '',
        globalMessage: []
    };
    sessionStorage.setItem(Config.sliceKey.messages, JSON.stringify(updatedState));
    return updatedState;
}

const initialState = initState();
const setMessage = (state, payload) => {
    const updatedGlobalMessage = state.globalMessage;
    const isErrorAlreadyExist = _.findIndex(updatedGlobalMessage, {code: payload.code}) >= 0;
    !isErrorAlreadyExist && updatedGlobalMessage.push(payload);
    const globalMessage = Array.from(new Set(updatedGlobalMessage.map(JSON.stringify))).map(JSON.parse);
    const updatedState = {
        ...state,
        hasMessage: true,
        globalMessage
    };
    sessionStorage.setItem(Config.sliceKey.messages, JSON.stringify(updatedState));
    return updatedState;
};
const clearMsMessage = (state, payload) => {
    const globalMessage = _.filter(state.globalMessage, (n) => {
        return n.actionType !== payload.actionType;
    });
    const updatedGlobalMessage = _.filter(globalMessage, (n) => {
        return n.actionType;
    });
    const updatedState = {
        ...state,
        hasMessage: updatedGlobalMessage.length > 0,
        globalMessage: updatedGlobalMessage
    };
    sessionStorage.setItem(Config.sliceKey.messages, JSON.stringify(updatedState));
    return updatedState;
};
const setMsMessage = (state, payload) => {
    const updatedGlobalMessage = state.globalMessage.concat(payload.globalMessage);
    const filteredGlobalMessage = Array.from(new Set(updatedGlobalMessage.map(JSON.stringify))).map(JSON.parse);
    const globalMessage = [...new Map(filteredGlobalMessage.map((item) => [item.code, item])).values()];
    const updatedState = {
        ...state,
        hasMessage: true,
        globalMessage
    };
    sessionStorage.setItem(Config.sliceKey.messages, JSON.stringify(updatedState));
    return updatedState;
};
const revokeMessage = (state) => {
    const updatedState = {
        ...state,
        hasMessage: false,
        type: '',
        globalMessage: []
    };
    sessionStorage.setItem(Config.sliceKey.messages, JSON.stringify(updatedState));
    return updatedState;
};

const reducer = (state = initialState, action) => {
    const {payload} = action;
    switch (action.type) {
        case actionTypes.SET_MESSAGE:
            return setMessage(state, payload);
        case actionTypes.SET_MS_MESSAGE:
            return setMsMessage(state, payload);
        case actionTypes.REVOKE_MESSAGE:
            return revokeMessage(state);
        case actionTypes.CLEAR_MS_MESSAGE:
            return clearMsMessage(state, payload);
        default:
            return state;
    }
};

export default reducer;
